// Hosts tab under SiteLayout — service-profile (1:1) + managed hosts (N).
// SiteLayout owns the PageHeader/tabs; this composes section headings only.

import { useIsPlatformAdmin } from "../auth/useIsPlatformAdmin";
import { ServiceProfileEditor } from "./ServiceProfileEditor";
import { HostsSection } from "./HostsSection";

export function SiteHostsPanel({
  accountSlug: _accountSlug,
  siteSlug,
}: {
  accountSlug: string;
  siteSlug: string;
}) {
  const canWrite = useIsPlatformAdmin();
  return (
    <div style={{ display: "grid", gap: 28 }}>
      <section>
        <h3 style={{ margin: "0 0 12px", fontSize: "0.95rem" }}>Service profile</h3>
        <ServiceProfileEditor siteSlug={siteSlug} canWrite={canWrite} />
      </section>
      <section>
        <HostsSection siteSlug={siteSlug} canWrite={canWrite} />
      </section>
    </div>
  );
}
